<div class="legend">
  <ng-container
    i18n="
      Heading Control|First part of heading for control and
      result@@HeadingCraneControlAndResult"
    >Crane Control And Results</ng-container
  ><span *ngIf="kranname !== ''"
    >&nbsp;<ng-container i18n="Text for|Just text: for@@For">for</ng-container>
    {{ kranname }}</span
  >
</div>
<div id="SteuerBereich">
  <div class="KranModell">
    <div class="Kranbild">
      <img [src]="grafikBasis + modelGraphicsPath + kranmodell" />
    </div>
    <div
      *ngIf="AdapterLaenge !== null && AdapterLaenge !== undefined"
      class="AdapterLaenge Kraneingabefelder EingabeFeldLang"
    >
      <input id="AdapterLaenge" readonly [value]="AdapterLaenge" />
      <span class="Icon_Input"
        ><img [src]="grafikBasis + modelGraphicsPath + 'AdapterSection.svg'"
      /></span>
      <span class="Bemassung_Input">{{ laengenEinheit }}</span>
    </div>
    <div
      class="HALaenge"
      [ngClass]="{
        MB_Only: Kombination.toLocaleLowerCase().includes('mb'),
        HDJ: Kombination.toLocaleLowerCase().includes('hdj'),
        MWL: Kombination.toLocaleLowerCase().includes('mwl'),
        BE:
          Kombination.toLocaleLowerCase().includes('be') &&
          !Kombination.toLocaleLowerCase().includes('bes'),
        BES: Kombination.toLocaleLowerCase().includes('bes'),
        LJ: Kombination.toLocaleLowerCase().includes('lj'),
        HIs_fest: hiFeldTyp === 'HIs_fest'
      }"
    >
      <div class="EingabeFeld">
        <select
          #HALaengeSelect
          id="HALaenge"
          (change)="haLaengeAendern(HALaengeSelect.value)"
        >
          <option
            *ngFor="let haLaenge of haLaengen"
            [value]="haLaenge"
            [selected]="haLaenge == aktuelleHALaenge"
          >
            {{ rundeHAWerte(haLaenge, stellenNachEinheitenSystem) }}
          </option>
        </select>
        <div id="HALaenge_EingabeFeld_Einheit">
          <span class="Bemassung_Dropdown">{{ laengenEinheit }}</span>
        </div>
      </div>
    </div>
    <div class="Gegengew">
      <div class="EingabeFeldMittel">
        <input
          #GegengewichtInput
          id="Gegengew"
          [value]="aktuellesGegengewicht"
          readonly
        />
      </div>
      <div id="Gegengew_EingabeFeld_Einheit">
        <span class="Bemassung_Input">{{ gewichtsEinheit }}</span>
      </div>
    </div>
    <div class="Radius">
      <div class="EingabeFeldMittel">
        <input
          #RadiusInput
          id="Radius"
          [value]="Radius"
          (change)="radiusAendern(RadiusInput.value)"
          (keyup.enter)="radiusAendern(RadiusInput.value)"
        />
      </div>
      <div id="Radius_EingabeFeld_Einheit">
        <span class="Bemassung_Input">{{ laengenEinheit }}</span>
      </div>
    </div>
    <div
      class="HAWinkel"
      [ngClass]="{
        MWL: Kombination.toLocaleLowerCase().includes('mwl'),
        MB_Only: Kombination.toLocaleLowerCase().includes('mb'),
        HDJ: Kombination.toLocaleLowerCase().includes('hdj'),
        BE:
          Kombination.toLocaleLowerCase().includes('be') &&
          !Kombination.toLocaleLowerCase().includes('bes'),
        BES: Kombination.toLocaleLowerCase().includes('bes'),
        LJ: Kombination.toLocaleLowerCase().includes('lj')
      }"
    >
      <div class="EingabeFeldMittel">
        <input
          *ngIf="hiFeldTyp !== 'HI_frei'"
          #HAWinkelInput
          id="HAWinkel"
          [value]="HAWinkel"
          (change)="haWinkelAendern(HAWinkelInput.value)"
          (keyup.enter)="haWinkelAendern(HAWinkelInput.value)"
        />
        <input
          *ngIf="hiFeldTyp == 'HI_frei'"
          #HAWinkelInput
          id="HAWinkel"
          [value]="HAWinkel"
          (change)="haWinkelAendern(HAWinkelInput.value)"
          (keyup.enter)="haWinkelAendern(HAWinkelInput.value)"
          readonly
        />
      </div>
      <div id="HAWinkel_EingabeFeld_Einheit">
        <span class="Bemassung_Input">°</span>
      </div>
    </div>
    <!--Teil fuer LJ, be, SA, ... -->
    <div *ngIf="hiFeldTyp !== 'KeinHI'">
      <div
        class="Kraneingabefelder HIWinkel"
        [ngClass]="{
          HI_frei: hiFeldTyp === 'HI_frei',
          HIs_fest: hiFeldTyp === 'HIs_fest',
          HI_zwischenwinkel: hiFeldTyp === 'HI_zwischenwinkel',
          MWL: Kombination.toLocaleLowerCase().includes('mwl'),
          LJ: Kombination.toLocaleLowerCase().includes('lj'),
          HDJ: Kombination.toLocaleLowerCase().includes('hdj'),
          BE:
            Kombination.toLocaleLowerCase().includes('be') &&
            !Kombination.toLocaleLowerCase().includes('bes'),
          BES: Kombination.toLocaleLowerCase().includes('bes'),
          LJ: Kombination.toLocaleLowerCase().includes('lj'),
          SA: Kombination.toLocaleLowerCase().includes('sa'),
          NoHiAngle: hiAsMbExtension == true
        }"
      >
        <div class="EingabeFeldMittel">
          <input
            #HIWinkelInput
            *ngIf="hiFeldTyp == 'HI_frei'"
            id="HIWinkel"
            [value]="hi1Winkel"
            (change)="hiWinkelAendern(HIWinkelInput.value)"
            (keyup.enter)="hiWinkelAendern(HIWinkelInput.value)"
          />
          <input
            #HIWinkelInput
            *ngIf="hiFeldTyp == 'HIs_fest'"
            id="HIWinkel"
            [value]="hi1Winkel"
            readonly
          />
          <select
            #HIWinkelInput
            *ngIf="hiFeldTyp == 'HI_zwischenwinkel'"
            id="HIWinkel"
            (change)="hiWinkelAendern(HIWinkelInput.value)"
            (keyup.enter)="hiWinkelAendern(HIWinkelInput.value)"
          >
            <option
              *ngFor="let HiW of moeglicheHi1Winkel"
              [value]="HiW"
              [selected]="hi1Winkel == HiW"
            >
              {{ HiW }}
            </option>
          </select>
        </div>
        <span class="Bemassung_Dropdown">°</span>
      </div>
      <div
        class="Kraneingabefelder HILaenge"
        [ngClass]="{
          HI_frei: hiFeldTyp === 'HI_frei',
          HIs_fest: hiFeldTyp === 'HIs_fest',
          HI_zwischenwinkel: hiFeldTyp === 'HI_zwischenwinkel',
          MWL: Kombination.toLocaleLowerCase().includes('mwl'),
          LJ: Kombination.toLocaleLowerCase().includes('lj'),
          HDJ: Kombination.toLocaleLowerCase().includes('hdj'),
          BE:
            Kombination.toLocaleLowerCase().includes('be') &&
            !Kombination.toLocaleLowerCase().includes('bes'),
          BES: Kombination.toLocaleLowerCase().includes('bes'),
          LJ: Kombination.toLocaleLowerCase().includes('lj'),
          SA: Kombination.toLocaleLowerCase().includes('sa')
        }"
      >
        <div class="EingabeFeldMittel">
          <input #HILaengeInput id="HILaenge" [value]="hi1Laenge" readonly />
        </div>
        <span class="Bemassung_Input">{{ laengenEinheit }}</span>
      </div>
    </div>
    <!--Ende LJ-->
  </div>
  <div class="KranDaten">
    <div class="HoeheWinkel">
      <div class="Zeile clearfix">
        <div class="Icon">
          <img [src]="grafikBasis + 'Rollenkopfhoehe.png'" />
        </div>
        <div class="Kraneingabefelder">
          <div class="EingabeFeldMittel">
            <input id="Hoehe" value="{{ RollenkopfHoehe }}" readonly /><span
              class="Bemassung_Input"
              >{{ laengenEinheit }}</span
            >
          </div>
        </div>
      </div>
      <div class="Zeile clearfix">
        <div class="Icon">
          <img [src]="grafikBasis + 'Drehwinkel.png'" />
        </div>
        <div class="Kraneingabefelder">
          <div class="EingabeFeldKurz">
            <div class="EingabeFeldKurz">
              <input
                #OWWinkelInput
                id="OWWinkel"
                [value]="OWWinkel"
                (change)="owWinkelAendern(OWWinkelInput.value)"
                (keyup.enter)="owWinkelAendern(OWWinkelInput.value)"
              /><span class="Bemassung_Input">°</span>
            </div>
          </div>
        </div>
      </div>
      <div class="Umruestung bstooltip">
        <!--Button zum Umruesten-->
        <input
          class="Umruesten"
          [style.opacity]="sichtbarkeitUmruestung"
          type="button"
          (click)="kranUmruesten()"
          id="Umruesten"
          value=""
        />
        <span class="tooltiptext attop">{{ UmruestenTooltip }}</span>
      </div>
    </div>
    <div class="Last" style="clear: both">
      <div class="Zeile clearfix">
        <div class="Icon">
          <img [src]="grafikBasis + 'Haken.png'" />
        </div>
        <div class="Kraneingabefelder">
          <div class="EingabeFeldKurz">
            <div>
              <img [src]="auslastungsAnzeige" />
              <div class="Auslastung">{{ Auslastung }}%</div>
            </div>
          </div>
        </div>
      </div>
      <div class="Zeile clearfix">
        <div
          class="Icon"
          i18n="Short for maximum|Short for maximum@@shortMaximum"
        >
          max
        </div>
        <div class="Kraneingabefelder">
          <div class="EingabeFeldExtraLang">
            <div class="FeldWeit">
              {{ Maxload
              }}<span class="Bemassung_Input">{{ gewichtsEinheit }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="Zeile clearfix">
        <div
          class="Icon"
          i18n="Short for actual|Abbreviation for actual@@ActualAbbreviated"
        >
          act
        </div>
        <div class="Kraneingabefelder">
          <div class="EingabeFeldExtraLang">
            <input
              #LastInput
              id="Last"
              [value]="Last"
              (change)="lastAendern(LastInput.value)"
              (keyup.enter)="lastAendern(LastInput.value)"
            />
            <span class="Bemassung_Input">{{ gewichtsEinheit }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="Abstuetzung clearfix">
      <div
        class="AbstuetzungInfo AbstuetzungHinten AbstuetzungRechts"
        [style.background-image]="stuetzeHR"
      >
        <div class="Stuetzlastwerte">
          <div class="Berechnung_MAX">
            {{ maxHintenRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
        <div class="Stuetzlastwerte">
          <div class="Berechnung">
            {{ actHintenRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
        <div class="AbstuetzungProzentHinten">
          <div class="Berechnung">{{ abstuetzungProzent.stuetzeHR }}%</div>
        </div>
      </div>
      <div
        class="AbstuetzungInfo AbstuetzungVorne AbstuetzungRechts"
        [style.background-image]="stuetzeVR"
      >
        <div class="AbstuetzungProzentVorne">
          <div class="Berechnung">{{ abstuetzungProzent.stuetzeVR }}%</div>
        </div>
        <div class="Stuetzlastwerte">
          <div class="Berechnung">
            {{ actVorneRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
        <div class="Stuetzlastwerte">
          <div class="Berechnung_MAX">
            {{ maxVorneRechts }}{{ gewichtsEinheit }}
          </div>
        </div>
      </div>
      <div
        class="AbstuetzungInfo AbstuetzungHinten AbstuetzungLinks"
        [style.background-image]="stuetzeHL"
      >
        <div class="Stuetzlastwerte">
          <div class="Berechnung_MAX">
            {{ maxHintenLinks }}{{ gewichtsEinheit }}
          </div>
        </div>
        <div class="Stuetzlastwerte">
          <div class="Berechnung">
            {{ actHintenLinks }}{{ gewichtsEinheit }}
          </div>
        </div>
        <div class="AbstuetzungProzentHinten">
          <div class="Berechnung">{{ abstuetzungProzent.stuetzeHL }}%</div>
        </div>
      </div>
      <div
        class="AbstuetzungInfo AbstuetzungVorne AbstuetzungLinks"
        [style.background-image]="stuetzeVL"
      >
        <div class="AbstuetzungProzentVorne">
          <div class="Berechnung">{{ abstuetzungProzent.stuetzeVL }}%</div>
        </div>
        <div class="Stuetzlastwerte">
          <div class="Berechnung">{{ actVorneLinks }}{{ gewichtsEinheit }}</div>
        </div>
        <div class="Stuetzlastwerte">
          <div class="Berechnung_MAX">
            {{ maxVorneLinks }}{{ gewichtsEinheit }}
          </div>
        </div>
      </div>
      <div
        class="AuslegerStrich"
        [style.width]="AuslegerStrichLaenge"
        [style.transform]="AuslegerStrichRotation"
      ></div>
      <div class="LastIcon clearfix" [style.transform]="translate"></div>
    </div>
  </div>
  <div class="KurzBeschreibung">
    <div class="FeldMitBeschreibung">
      <div class="Beschreibung" style="float: left; vertical-align: middle">
        <ng-container
          i18n="
            Short Description|A short description of the
            project@@ShortDescription"
          >short description</ng-container
        >:
      </div>
      <div class="EingabeFeldInfo" style="float: left">
        <input
          type="text"
          maxlength="66"
          id="Information"
          [value]="description"
          (change)="setzeBeschreibung($event)"
          (keyup.enter)="setzeBeschreibung($event)"
        />
      </div>
    </div>
    <div style="float: right">
      <a class="css-button" (click)="Print()">
        <span class="css-button-text"
          ><ng-container
            i18n="Call print dialog|Labeling for print button@@printLabel"
            >Print</ng-container
          ></span
        >
      </a>
    </div>
  </div>
</div>
<div class="clearfix"></div>
<div class="LoadCharts">
  <div
    class="legend"
    i18n="
      Heading load charts|Heading for area with load charts with
      control@@LoadChartHeading"
  >
    Load Charts
  </div>
  <ej-grid
    #LastTabelle
    allowResizeToFit="true"
    [allowFiltering]="true"
    [filterSettings]="filterType"
    [allowPaging]="true"
    [pageSettings]="tabellenEinstellungen['pageSettings']"
    [allowSorting]="false"
    [dataSource]="gridData"
    selectionType="single"
    allowSelection="true"
    [selectionSettings]="tabellenEinstellungen['selectionMode']"
    (rowSelected)="rowSelected()"
  >
    <e-columns>
      <!-- <e-column type="checkbox" width="50"></e-column> //enables the checkbox column textAlign="right"-->
      <e-column
        field="Radius"
        i18n-headerText="
          Table header radius|Header for Radius in load chart table@@Radius"
        headerText="Radius"
        [visible]="true"
      ></e-column>
      <e-column
        field="Last"
        i18n-headerText="
          Table header load|Header for load in load chart table@@Load"
        headerText="Load"
      ></e-column>
      <e-column
        field="Hoehe"
        i18n-headerText="
          Table header height|Header for height in load chart table@@Height"
        headerText="Height"
        [visible]="true"
      ></e-column>
    </e-columns>
  </ej-grid>
</div>
<!--<div style="position:absolute;top:850px;"><input type="button" name="Print" value="Test" (click)="test()" /></div>-->
<div *ngIf="bitteWarten()" class="sanduhr">
  <div class="sanduhrDisplay"></div>
</div>
<app-fehlermeldung
  [FehlerUeberschrift]="FehlerUeberschrift"
  [FehlerHinweis]="FehlerHinweis"
  [(zeigeFehlerMeldungSchalter)]="zeigeFehlerMeldung"
  [FehlerCallback]="FehlerCallback"
></app-fehlermeldung>
<div *ngIf="zeigeDialog" class="sanduhr">
  <div class="Dialog" [innerHTML]="dialogHTML"></div>
</div>
<!-- <div style="position:absolute;top:500px;left:-200px;">
ladeKran: {{this.ladeKran}}<br />
aktualisiereAnzeige: {{this.aktualisiereAnzeige}}<br />
ergebnisseAktualisieren: {{this.ergebnisseAktualisieren}}<br />
ergebnisseAktualisieren: {{this.ergebnisseAktualisieren}}<br />
ruestdatenAktualisieren: {{this.ruestdatenAktualisieren}}<br />
MAXWerteAktualisieren: {{this.MAXWerteAktualisieren}}<br />
haSelect_disabled: {{this.haSelect_disabled}}<br />
radiusGesetzt: {{this.radiusGesetzt}}<br />
lastGesetzt: {{this.lastGesetzt}}<br />
owWinkelGesetzt: {{this.owWinkelGesetzt}}<br />
initialisereKran: {{this.initialisiereKran}}<br />
</div> -->
